import { BaseObject, IBaseObjectArgs } from "../../../core/business-objects/base-object/base-object.model";

export interface IControlTypeArgs extends IBaseObjectArgs {
    name: string;
}

const defaults = {
    name: ""
} as IControlTypeArgs;

export class ControlType extends BaseObject {
    name: string;

    constructor(data?: IControlTypeArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/control-type/control-type.model.ts